import React from 'react';
import { bool, shape, string } from 'prop-types';

const WorksInTerritory = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 11.001H12V15.9004C11.9997 18.9001 9.89981 21.401 7 22.001C4.10019 21.401 2.00027 18.9001 2 15.9004V11.001H6V2H8V11.001ZM4 15.9004C4.00025 17.8001 5.2002 19.4004 7 19.9004C8.79979 19.4004 9.99974 17.7002 10 15.9004V13.001H8V16H6V13.001H4V15.9004Z" fill="currentColor" />
    <path d="M14 6C14 7.34623 14.8165 8.43833 16 8.83594V2C16.0234 2 18 2 18 2V8.83594C18.684 8.60615 19.2437 8.1429 19.5957 7.53418C19.7004 7.35308 19.7881 7.15994 19.8535 6.95508C19.9011 6.80614 19.9382 6.65165 19.9629 6.49219C19.9876 6.33269 20 6.1683 20 6V2H22V6C21.9999 6.76761 21.8349 7.49032 21.5371 8.13477C21.4235 8.38058 21.29 8.61468 21.1396 8.83594C21.014 9.02091 20.8765 9.19684 20.7275 9.36231C20.6342 9.46604 20.5364 9.56576 20.4346 9.66114C20.1799 9.8997 19.8996 10.1114 19.5977 10.292C19.5373 10.3281 19.4761 10.3629 19.4141 10.3965C19.1037 10.5645 18.7725 10.7007 18.4248 10.8008C18.3555 10.8207 18.2855 10.8394 18.2148 10.8564C18.1439 10.8736 18.0722 10.8892 18 10.9033V21.9287H16V10.9033C13.6936 10.451 12 8.45661 12 6V2H14V6Z" fill="currentColor" />
  </svg>
);

WorksInTerritory.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default WorksInTerritory;
